import { useState, useEffect } from 'react';
import { getSyncQueue } from '@/lib/syncQueue';

export function useNetworkStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [pendingCount, setPendingCount] = useState(getSyncQueue().length);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Monitor local storage for queue changes (from other tabs)
    const handleStorage = (e: StorageEvent) => {
      if (e.key === 'team-v-does-sync-queue') {
        setPendingCount(getSyncQueue().length);
      }
    };
    window.addEventListener('storage', handleStorage);

    // Periodic check for queue count if updated in same tab
    const interval = setInterval(() => {
        setPendingCount(getSyncQueue().length);
    }, 2000);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('storage', handleStorage);
      clearInterval(interval);
    };
  }, []);

  return { isOnline, pendingCount };
}
